module.exports = __webpack_public_path__ + "img/btn_my_record_on.755e13b2.png";